import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

export const pricingService = {
  getPricingList$(country) {
    return rxios.get(`/homepage/v1/pricing`, { params: { country } }).pipe(map(response => response.data.pricingList))
  }
}
